export const getImageByScreenMode = (data, screenMode, imageName) =>
  data[`${screenMode}${imageName}`] || '';
